import _kebabCase from 'lodash/kebabCase';
import { Google } from '../analytics/index.js';

/**
 * @summary Sends Adobe/Google event when search badge is submitted
 * @cmp spec_v
 * @events event1
 */

export async function footerLinkClick(_ref, option) {
  let {
    data = {}
  } = _ref;
  const {
    type = '',
    text = '',
    pagetype = '',
    appStoreName = ''
  } = data;
  let result = '';
  if (appStoreName) {
    result = `icon::${appStoreName}`;
  } else {
    const linkCopy = _kebabCase(text);
    // fires correct tag for ico, additional links, and internal links
    if (type === 'main' && linkCopy === 'trade-in-a-car') {
      result = `text-link::global-nav-footer::${linkCopy}`;
    } else if (type === 'additional') {
      result = `text-link::${linkCopy}::${linkCopy}`;
    } else if (pagetype) {
      result = `text-link::${pagetype}::${linkCopy}`;
    } else if (linkCopy === 'manage-cookies') {
      result = `text-link::${linkCopy}`;
    }
  }
  Google.sendClickEvent({
    eventElement: 'global-nav-footer',
    eventResult: result,
    eventNonInteractive: false
  }, option);
  return {};
}
export default {
  footerLinkClick
};